import { actionTypes } from '../../../types';

// Action creator for generating OTP request
export const getCityByState = (payload, callback) => ({
    type: actionTypes.GET_CITY_BY_STATE_REQUEST,
    payload,
    callback,
});

// Action creator for successful OTP generation
export const getCityByStateSuccess = (payload) => ({
    type: actionTypes.GET_CITY_BY_STATE_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const getCityByStateFailure = (payload) => ({
    type: actionTypes.GET_CITY_BY_STATE_FAILURE,
    payload,
});

// Action creator for resetting OTP generation status
export const getCityByStateReset = () => ({
    type: actionTypes.GET_CITY_BY_STATE_RESET,
});

// Action creator for resetting all OTP generation reducer
export const getCityByStateResetAll = () => ({
    type: actionTypes.GET_CITY_BY_STATE_RESET_ALL,
}); 